import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { TabsContent } from '@/components/ui/tabs';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { formatCurrency, formatPercent } from '@/lib/utils/formatters';
import { useGestaoImpostosContext } from '@/contexts';

export function SimulacaoTransicaoTab() {
  const { isLoadingSituacaoAtual, projecaoCompleta } = useGestaoImpostosContext();

  return (
    <TabsContent value="transicao" className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Simulação da Transição Tributária</CardTitle>
          <CardDescription>
            Projeção da carga tributária durante o período de transição (2026-2033)
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Ano</TableHead>
                <TableHead className="text-right">% IBS</TableHead>
                <TableHead className="text-right">% CBS</TableHead>
                <TableHead className="text-right">ICMS</TableHead>
                <TableHead className="text-right">IPI</TableHead>
                <TableHead className="text-right">IBS</TableHead>
                <TableHead className="text-right">CBS</TableHead>
                <TableHead className="text-right">IS</TableHead>
                <TableHead className="text-right">Total</TableHead>
                <TableHead className="text-right">% s/ Vendas</TableHead>
                <TableHead className="text-right">Variação</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoadingSituacaoAtual || !projecaoCompleta
                ? Array.from({ length: 8 }).map((_, i) => (
                    <TableRow key={i}>
                      {Array.from({ length: 11 }).map((__, j) => (
                        <TableCell key={j}>
                          <Skeleton className="h-4 w-full" />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                : projecaoCompleta.anos.map(ano => (
                    <TableRow key={ano.ano}>
                      <TableCell className="font-medium">{ano.ano}</TableCell>
                      <TableCell className="text-right">
                        {formatPercent(ano.percentualIBS / 100)}
                      </TableCell>
                      <TableCell className="text-right">
                        {formatPercent(ano.percentualCBS / 100)}
                      </TableCell>
                      <TableCell className="text-right">{formatCurrency(ano.icms.valor)}</TableCell>
                      <TableCell className="text-right">{formatCurrency(ano.ipi.valor)}</TableCell>
                      <TableCell className="text-right text-primary">
                        {formatCurrency(ano.ibs.valor)}
                      </TableCell>
                      <TableCell className="text-right text-primary">
                        {formatCurrency(ano.cbs.valor)}
                      </TableCell>
                      <TableCell className="text-right">{formatCurrency(ano.is.valor)}</TableCell>
                      <TableCell className="text-right font-semibold">
                        {formatCurrency(ano.total.valor)}
                      </TableCell>
                      <TableCell className="text-right">
                        {formatPercent(ano.total.percentualSobreVendas)}
                      </TableCell>
                      <TableCell className="text-right">
                        {ano.variacaoAnoAnterior === 0 ? (
                          '-'
                        ) : ano.variacaoAnoAnterior < 0 ? (
                          <span className="text-green-600 flex items-center justify-end gap-1">
                            <TrendingDown className="h-4 w-4" />
                            {formatCurrency(Math.abs(ano.variacaoAnoAnterior))}
                          </span>
                        ) : (
                          <span className="text-red-600 flex items-center justify-end gap-1">
                            <TrendingUp className="h-4 w-4" />
                            {formatCurrency(ano.variacaoAnoAnterior)}
                          </span>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>

          {projecaoCompleta && (
            <div className="grid gap-4 md:grid-cols-3 pt-2">
              <div className="p-4 border rounded-lg">
                <div className="text-sm text-muted-foreground">Carga Atual (2026)</div>
                <div className="text-xl font-bold">
                  {formatPercent(projecaoCompleta.cargaAtual)}
                </div>
              </div>
              <div className="p-4 border rounded-lg">
                <div className="text-sm text-muted-foreground">Carga Final (2033)</div>
                <div className="text-xl font-bold text-green-600">
                  {formatPercent(projecaoCompleta.cargaFinal)}
                </div>
              </div>
              <div className="p-4 border rounded-lg">
                <div className="text-sm text-muted-foreground">Redução Total</div>
                <div className="text-xl font-bold text-green-600">
                  {formatPercent(projecaoCompleta.reducaoTotalPontosPercentuais).replace(
                    '%',
                    ' p.p.'
                  )}
                </div>
              </div>
            </div>
          )}

          <p className="text-xs text-muted-foreground pt-2 border-t">
            Cronograma de transição conforme a Lei Complementar nº 214/2025 (Reforma Tributária).
            Valores projetados a partir dos dados reais do período selecionado — sujeitos a
            alteração conforme regulamentação futura.
          </p>
        </CardContent>
      </Card>
    </TabsContent>
  );
}
